export const PATTERN_DATE = 'dd MMM yyyy';
export const PATTERN_DATE_TIME = 'dd MMM yyyy hh:mm:ss a';
